import { createStore } from "vuex";
import { auth } from "./auth.module";
import { loader } from "./loader.module";

const store = createStore({
  modules: {
    auth,
    loader,
  },
});

export default store;